import Rete from "rete";
import {
  NumberSocket,
  NumberControl
} from "../../rete-controls/NumberControl.js";

import AnyTypeSocket, { ArraySocket } from "../../../Utils/CommonSockets.js";
import { ResetSocket } from "../../rete-controls/ResetControl.js";
import { EventBus } from "../../../event-bus.js";

export default class AnyArrayCollector extends Rete.Component {
  constructor() {
    super("Any Expander"); // name
    this._categories = ["Simulator"];
    this._outKeyBase = "out";
    this._nodeStateData = {};
    this._eventRegistered = false;
    EventBus.$on("global-reset-nodes", x => {
      this.doResetNode("all");
    });
  }

  buildNodeData(node) {
    if (node !== null && node !== undefined && node.id != undefined) {
      this._nodeStateData[node.id] = {
        myArray: [],
        currentCount: 0,
        reset() {
          this.myArray = [];
        }
      };
    }
  }
  registerOnRemove() {
    if (!this._eventRegistered) {
      var data = this._nodeStateData;
      this.editor.on("noderemoved", nodex => {
        console.log("removing " + nodex.id);

        if (data[nodex.id] !== null && data[nodex.id] !== undefined) {
          console.log("data gone " + nodex.id);

          delete data[nodex.id];
        }
      });
    }
    this._eventRegistered = true;
  }

  builder(node) {
    var inp1 = new Rete.Input("in1", "Any Array", AnyTypeSocket);
    var inp3 = new Rete.Input("resetIn", "Reset", ResetSocket);

    let numControl = new NumberControl(this.editor, "size", false);

    this.buildNodeData(node);
    this.registerOnRemove();

    let count = +node.data.size;
    if (Number.isNaN(count) || count <= 0) count = 1;
    this.updateNodeOutput(node, 0, count, true);

    return node
      .addInput(inp1)
      .addInput(inp3)
      .addControl(numControl);
  }

  doResetNode(node) {
    if (node == "all") {
      for (const key in this._nodeStateData) {
        if (this._nodeStateData.hasOwnProperty(key)) {
          const element = this._nodeStateData[key];
          element.reset();
        }
      }
    } else {
      this._nodeStateData[node.id].reset();
    }
  }
  resetNode(in3, node) {
    if (node.inputs["resetIn"].connections[0] != null)
      if (in3 !== null && in3 !== undefined) this.doResetNode(node);
  }

  updateNodeOutput(node, oldSize, newSize, skipUpdate) {
    var doUpdate = false;

    if (oldSize < newSize) {
      //add
      for (let index = 0; index < newSize; index++) {
        if (!node.outputs.has(this._outKeyBase + index)) {
          node.addOutput(
            new Rete.Output(this._outKeyBase + index, "OUT" + index, AnyTypeSocket)
          );
        }
      }
      doUpdate = true;
    } else if (oldSize > newSize) {
      //remove
      for (let index = newSize; index < oldSize; index++) {
        if (node.outputs.has(this._outKeyBase + index)) {
          node.removeOutput(
            new Rete.Output(this._outKeyBase + index, "OUT" + index, AnyTypeSocket)
          );
        }
      }
      doUpdate = true;
    }
    if (!skipUpdate && doUpdate) node.update();
    this._nodeStateData[node.id].currentCount = newSize;
  }
  worker(node, inputs, outputs) {
    this.resetNode(inputs["resetIn"][0], node);

    let in1 = inputs["in1"][0];
    let count = +node.data.size;
    if (Number.isNaN(count) || count <= 0) count = 1;

    let currentCount = this._nodeStateData[node.id].currentCount;
    let arrayValue = [];

    let currentNode = this.editor.nodes.find(n => n.id == node.id);
    this.updateNodeOutput(currentNode, currentCount, count, false);
    
    currentCount = this._nodeStateData[node.id].currentCount;

    arrayValue = in1;
    if (!(arrayValue instanceof Array))
      if (arrayValue instanceof Object)
        if (typeof arrayValue.asArray === "function") {
          arrayValue = arrayValue.asArray();
        }

        for (let index = 0; index < currentCount ; index++) {
          if(arrayValue !== undefined && arrayValue.length > index)
          {
            const element = arrayValue[index];
            outputs[this._outKeyBase + index] = element;
          }
          else{
            delete outputs[this._outKeyBase + index];
          }
          
        }
  }
}
